
import React from 'react';

const partnersData = [
  {
    name: "Leadinfo",
    logo: "/lovable-uploads/2dfecbf7-867c-462f-a824-dad8ce0b9691.png"
  },
  {
    name: "Microsoft",
    logo: "/lovable-uploads/b378c721-3200-4f61-9c5d-0b3af98392ab.png"
  },
  {
    name: "Make",
    logo: "/lovable-uploads/94364555-f89e-4afc-97c8-7f2a2a789044.png"
  },
  {
    name: "Trendstop",
    logo: "/lovable-uploads/a3d012c3-640c-4348-891b-8a1f8b1c1426.png"
  },
  {
    name: "Vlajo",
    logo: "/lovable-uploads/4ff51466-52dd-4438-bff5-04cec032b4e2.png"
  },
  {
    name: "Podio",
    logo: "/lovable-uploads/70590bfb-0f5c-4aff-9d5c-9fadd74c1044.png"
  }
];

const PartnersSection = () => {
  return (
    <section className="bg-brand-gray section">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Onze partners</h2>
          <p className="section-subtitle mx-auto">
            We werken samen met toonaangevende organisaties om jou de beste service te bieden.
          </p>
        </div>
        
        <div className="flex flex-wrap justify-center gap-8 md:gap-16">
          {partnersData.map((partner, index) => (
            <div key={index} className="w-36 h-24 bg-white flex items-center justify-center rounded-md shadow-sm p-4">
              <img 
                src={partner.logo} 
                alt={`${partner.name} Logo`}
                className="max-w-full max-h-full"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
